import { style } from "@angular/animations";
import { DizionarioModel } from "../../models/shared/dizionario.model";
import { Component, ViewContainerRef, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/fromEvent";
import { Location } from "@angular/common";
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
// import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { MdSnackBar } from "@angular/material";

import { AppComponent } from "../../app.component";
import { ILoginModel } from "../../models/account/ilogin.model";
import { AuthService } from "./../../services/auth.service";
import { IResetModel } from "../../models/account/ilogin-reset.model";
import { UserModel } from "../../models/user/user.model";
import { BrogliacciService } from "../../services/brogliacci.service";
import { LangService } from "../../services/lang.services";
import { UltimaVersioneApplicativoClientService } from "../../services/ultima-versione-applicativo-client.service";
import { Configurations } from "../../core/configurations";
import { SharedService } from "../../services/shared.service";

import * as _ from "lodash";
@Component({
  selector: "account-login",
  moduleId: module.id,
  templateUrl: "account-login.component.html",
  styles: [".loginbox { min-width: 320px; max-width: 360px; margin: 0 auto;}"],
})
export class AccountLoginComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  loginForm: FormGroup;
  resetForm: FormGroup;
  ruoli: DizionarioModel[] = null;
  reset: string;
  user: UserModel;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthService,
    private formBuilder: FormBuilder,
    private snackBar: MdSnackBar,
    private _vcr: ViewContainerRef,
    private appComponent: AppComponent,
    private _authService: AuthService,
    private _langService: LangService,
    private _brogliacciService: BrogliacciService,
    private _ultimaVersioneClientTipo: UltimaVersioneApplicativoClientService,
    private _sharedService: SharedService
  ) {
    //this.authenticationService.getAllRoles().subscribe(r => this.ruoli = r);
  }

  ngOnInit() {
    this._langService.setLang("it");
    this._ultimaVersioneClientTipo
      .getUltimaVersioneApplicativo()
      .subscribe((data) => {
        Configurations.currentVersionCod = data.codice;
      });
    //get return url from route parameters or default to '/'
    //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.loginForm = null;
    this.resetForm = null;
    this.returnUrl = "";
    this.route.queryParamMap
      .map((params) => params.get("returnUrl") || "")
      .subscribe((x) => (this.returnUrl = x));

    let message = "";
    this.route.queryParamMap
      .map((params) => params.get("message") || "")
      .subscribe((x) => (message = x));

    this.route.queryParamMap
      .map((params) => params.get("reset") || "False")
      .subscribe((x) => (this.reset = x));

    if (message !== "") {
      this.showError(message);
    }
    if (this.reset === "True") {
      this.user = this._authService.user;
      this.buildFormReset(this.user.username, this.user.email);
    } else {
      // reset login status
      this.authenticationService.logout(false);
      this.buildForm();
    }
  }

  onSubmitLogin() {
    this.loading = true;
    this.authenticationService
      .login(this.loginForm.value as ILoginModel)
      .finally(() => {
        this.loading = false;
      })
      .subscribe(
        (data) => {
          if (data.isAuthenticated === true) {
            this.router.navigate([""]);
            window.location.href = this.returnUrl;
          } else {
            if (data.loginIncorrect === true) {
              this.showError(data.messaggio);
            } else if (data.passwordExpired === true) {
              this.showWarning("Confermare le credenziali di accesso");
              this.loginForm = null;
              this.resetForm = null;
              this.buildFormReset(data.userName, data.email);
              let navigationExtras: NavigationExtras = {
                queryParams: { reset: "True" },
              };
              this.router.navigate(["/login"], navigationExtras);
            } else if (data.userMustBeActivated) {
              this.showError("Utente non attivo");
            }
          }
        },
        (error) => {
          this.showWarning("Dati di accesso non validi");
        }
      );
  }

  onSubmitReset() {
    this.loading = true;
    if (this.resetForm) {
      let isCorrectForm =
        this.resetForm.get("confermaPassword").value ===
        this.resetForm.get("newPassword").value;

      if (!isCorrectForm) {
        this.showError(
          "La nuova password e quella di conferma non corrispondono."
        );
        this.loading = false;
        return false;
      }

      if (
        this.resetForm.get("confermaPassword").value === "" ||
        this.resetForm.get("newPassword").value === "" ||
        this.resetForm.get("username").value === "" ||
        this.resetForm.get("email").value === "" ||
        this.resetForm.get("oldPassword").value === ""
      ) {
        this.showError("Compilare tutti i dati per poter procedere");
        this.loading = false;
        return false;
      }

      this.authenticationService
        .resetPassword(this.resetForm.value as IResetModel)
        .finally(() => {
          this.loading = false;
        })
        .subscribe(
          (data: any) => {
            if (data.passwordHasBeenChanged) {
              this.showWarning("Credenziali aggiornate con successo.");
              this.loginForm = null;
              this.resetForm = null;
              this.buildForm();
              let navigationExtras: NavigationExtras = {
                queryParams: { reset: "False" },
              };
              this.router.navigate(["/login"], navigationExtras);
            } else {
              this.showError(data.messaggio);
            }
          },
          (error) => {
            this.showError(error);
          }
        );
    }
  }

  private showError(message: string) {
    this.snackBar.open("Errore: " + message, "Chiudi", { duration: 10000 });
    console.log(message);
  }

  private showWarning(message: string) {
    this.snackBar.open(message, "Chiudi", { duration: 10000 });
    console.log(message);
  }

  buildForm(): void {
    this.loginForm = this.formBuilder.group({
      nomeUtente: [null, Validators.required],
      password: [null, Validators.required],
      role: [null, Validators.required],
    });
  }

  buildFormReset(username?, email?): void {
    this.resetForm = this.formBuilder.group({
      username: [username, Validators.required],
      email: [email, Validators.required],
      oldPassword: [null, Validators.required],
      newPassword: [null, Validators.required],
      confermaPassword: [null, Validators.required],
    });
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/account/account-login.component.ts